export const GET_HISTORYBYITEM_REPORT = 'GET_HISTORYBYITEM_REPORT';
export const GET_HISTORYBYITEM_REPORT_ERROR = 'GET_HISTORYBYITEM_REPORT_ERROR';
export const HISTORYBYITEM_REPORT_LOAD = 'HISTORYBYITEM_REPORT_LOAD';

export const GET_HISTORYBYSTUDENT_REPORT = 'GET_HISTORYBYSTUDENT_REPORT';
export const GET_HISTORYBYSTUDENT_REPORT_ERROR = 'GET_HISTORYBYSTUDENT_REPORT_ERROR';
export const HISTORYBYSTUDENT_REPORT_LOAD = 'HISTORYBYSTUDENT_REPORT_LOAD';

export const GET_HISTORYBYDATE_REPORT = 'GET_HISTORYBYDATE_REPORT';
export const GET_HISTORYBYDATE_REPORT_ERROR = 'GET_HISTORYBYDATE_REPORT_ERROR';
export const HISTORYBYDATE_REPORT_LOAD = 'HISTORYBYDATE_REPORT_LOAD';

export const CLEAR_REPORT_DATA = 'CLEAR_REPORT_DATA';
export const GET_HISTORYBYSTUDENT_USER = 'GET_HISTORYBYSTUDENT_USER';
export const GET_HISTORYBYSTUDENT_USER_ERROR = 'GET_HISTORYBYSTUDENT_USER_ERROR';
export const USER_LOAD = 'USER_LOAD';



// WEBPACK FOOTER //
// ./src/pages/transactionhistory/state/types.js